import React, { useEffect, useState } from 'react';
import Alert from '@material-ui/lab/Alert';
import { abortableFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function UnfinishedTasksWarning({
  esFileId,
}: {
  esFileId?: string;
}) {
  const [hasUnfinishedTasks, setHasUnfinishedTasks] = useState<boolean | null>(
    null
  );
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!esFileId) {
      setHasUnfinishedTasks(null);
      return;
    }

    let canceled = false;
    setHasUnfinishedTasks(null);
    setFailed(false);

    abortableFetch(
      `${EvidenceApiUrl.ES_FILES}/${esFileId}/task/unfinished-exists`
    )
      .json()
      .then((exists) => {
        if (!canceled) {
          setHasUnfinishedTasks(Boolean(exists));
        }
      })
      .catch(() => {
        if (!canceled) {
          setFailed(true);
        }
      });

    return () => {
      canceled = true;
    };
  }, [esFileId]);

  if (!hasUnfinishedTasks && !failed) {
    return null;
  }

  return (
    <Alert severity="warning">
      {failed
        ? 'Existenci nevyřízených úloh se nepodařilo ověřit.'
        : 'Spis obsahuje nevyřízené úlohy. Úlohy zůstanou ke zpracování a lze je vyřídit i po uzavření spisu.'}
    </Alert>
  );
}
